export const FETCH_FOOD_MOODS = {
  START: 'START_FETCH_FOOD_MOODS',
  COMPLETE: 'COMPLETE_FETCH_FOOD_MOODS',
  FAIL: 'FAIL_FETCH_FOOD_MOODS',
  CLEANUP: 'CLEANUP_FETCH_FOOD_MOODS',
}

export const ADD_FOOD_MOOD = 'ADD_FOOD_MOOD'
export const RENAME_FOOD_MOOD = 'RENAME_FOOD_MOOD'
export const RESET_FOOD_MOOD_TREE = 'RESET_FOOD_MOOD_TREE'

export const SET_DATA_FOR_RENAMING_FOOD_MOOD = 'SET_DATA_FOR_RENAMING_FOOD_MOOD'

export const DELETE_FOOD_MOOD = {
  START: 'START_DELETE_FOOD_MOOD',
  COMPLETE: 'COMPLETE_DELETE_FOOD_MOOD',
  FAIL: 'FAIL_DELETE_FOOD_MOOD',
}

export const SAVE_FOOD_MOODS = {
  START: 'START_SAVE_FOOD_MOODS',
  COMPLETE: 'COMPLETE_SAVE_FOOD_MOODS',
  FAIL: 'FAIL_SAVE_FOOD_MOODS',
}
